import { useMemo } from 'react';

import { selectUserEndpointToken } from 'modules/account/store/selectors';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchAccountStatusParams,
  selectAccountStatus,
  selectAccountStatusInitialLoading,
  selectAccountStatusLoading,
} from '../actions/fetchAccountStatus';
import {
  selectAccountStatusError,
  selectAccountStatusLoaded,
  selectIsEnterprise,
  selectIsFreemium,
  selectIsInactive,
  selectIsPremium,
} from '../store/selectors';

export const useAccountStatus = () => {
  const userEndpointToken = useAppSelector(selectUserEndpointToken);

  const params = useMemo(
    (): IFetchAccountStatusParams => ({
      userEndpointToken: userEndpointToken!,
    }),
    [userEndpointToken],
  );

  const accountStatus = useAppSelector(state =>
    selectAccountStatus(state, params),
  );
  const error = useAppSelector(state =>
    selectAccountStatusError(state, params),
  );
  const initalLoading = useAppSelector(state =>
    selectAccountStatusInitialLoading(state, params),
  );
  const loaded = useAppSelector(state =>
    selectAccountStatusLoaded(state, params),
  );
  const loading = useAppSelector(state =>
    selectAccountStatusLoading(state, params),
  );
  const isEnterprise = useAppSelector(state =>
    selectIsEnterprise(state, params),
  );
  const isInactive = useAppSelector(state => selectIsInactive(state, params));
  const isFreemium = useAppSelector(state => selectIsFreemium(state, params));
  const isPremium = useAppSelector(state => selectIsPremium(state, params));

  return {
    accountStatus,
    error,
    initalLoading,
    isEnterprise,
    isFreemium,
    isInactive,
    isPremium,
    loaded,
    loading,
  };
};
